import React, { FC, useRef, useState } from 'react';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { contentModalViewStore } from 'src/store/modal';
import { myInfoDataStore } from 'src/store/myInfo';
import CompanyCurrentDetail from 'src/components/molecules/table/CompanyCurrentDetail';
import IconButton from 'src/components/atoms/buttons/IconButton';
import CheckBox from 'src/components/atoms/CheckBox';

export const gridOption = (data: any, orgData: any, totalCount: number, bindStateData: any) => {
  const gridData = _.cloneDeep(data) || [];
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  const myInfoDataStateResult = myInfoDataStore((state: any) => state.result).data || {};

  const disableEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const gridFnc = {
    viewContent: (param: any) => {
      const companyName = param[0] || '';
      const data = { companyName };

      const viewModal = (e: any) => {
        const payload = {
          active: '_active',
          // title: companyName,
          title: '  현재 근무지',
          content: <CompanyCurrentDetail type="list" data={orgData} />,
          styleDef: { width: '1024px' },
        };
        setContentModalState(payload);
      };

      return (
        <div className="_custom_div_center" style={{ width: '45px', height: '45px' }}>
          <IconButton
            clickEvent={e => viewModal(e)}
            icon="ri-file-list-line"
            type="type3"
            styleDef={{ fontSize: '15px', width: '28px', height: '28px' }}
          />
        </div>
      );
    },
    createDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
    },
    setDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD');
    },
    viewCount: (param: any) => {
      const count = param[0] || 0;
      return addComma(count);
    },
  };

  // gridData
  const gridOption = {
    label: [
      {
        label: '',
        col: 'id',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      // {
      //   label: '회사명',
      //   col: 'company',
      //   width: 'calc(100% - 560px)',
      //   align: 'left',
      //   sort: { use: false, active: false, status: 'desc' },
      // },
      {
        label: '급여',
        col: 'tsal_base',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['tsal_base'] },
      },
      {
        label: '상여',
        col: 'tsal_bonus',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['tsal_bonus'] },
      },
      {
        label: '소득세',
        col: 'tax_income',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['tax_income'] },
      },
      {
        label: '국민연금보험료',
        col: 'ppen_national',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['ppen_national'] },
      },
      // {
      //   label: '사업자등록번호',
      //   col: 'businessNum',
      //   width: '120px',
      //   align: 'center',
      //   sort: { use: false, active: true, status: 'desc' },
      // },
      {
        label: '건강보험료',
        col: 'pins_health',
        width: '120px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['pins_health'] },
        // custom: { fn: gridFnc.setDate, param: ['start_date'] },
      },
      {
        label: '고용보험료',
        col: 'pins_emp',
        width: '120px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['pins_emp'] },
        // custom: { fn: gridFnc.setDate, param: ['end_date'] },
      },
      {
        label: '',
        col: '',
        width: '50px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewContent, param: ['company'] },
      },
    ],
    styleDef: { width: '100%', fontSize: '13px' },
    data: gridData,
    totalCount: totalCount,
  };

  return gridOption;
};
